import React from "react";
interface IconProps {
	fill: string;
	class?: string;
	className?: string;
	height: number;
}


export const ManipulateIcon = (props: IconProps) => (
	<svg fill={props.fill} className={props.class} viewBox="0 0 422 422" width={props.height} height={props.height} >
		<g>
        <path d="M401.768,129.995H292.239c-0.128,0-0.233-0.104-0.233-0.233V20.233C292.006,9.076,282.929,0,271.773,0H150.228
		c-11.156,0-20.233,9.076-20.233,20.233v109.529c0,0.128-0.104,0.233-0.233,0.233H20.233C9.077,129.995,0,139.071,0,150.228v121.545
		c0,11.156,9.077,20.233,20.233,20.233h109.529c0.128,0,0.233,0.104,0.233,0.233v109.529c0,11.156,9.077,20.233,20.233,20.233
		h121.545c11.156,0,20.233-9.076,20.233-20.233V292.238c0-0.128,0.104-0.233,0.233-0.233h109.529
		c11.156,0,20.232-9.076,20.232-20.233V150.228C422,139.071,412.924,129.995,401.768,129.995z M402,271.773
		c0,0.128-0.104,0.233-0.232,0.233H292.239c-11.156,0-20.233,9.076-20.233,20.233v109.529c0,0.128-0.104,0.233-0.233,0.233H150.228
		c-0.128,0-0.233-0.104-0.233-0.233V292.238c0-11.156-9.077-20.233-20.233-20.233H20.233c-0.128,0-0.233-0.104-0.233-0.233V150.228
		c0-0.128,0.104-0.233,0.233-0.233h109.529c11.156,0,20.233-9.076,20.233-20.233V20.233c0-0.128,0.104-0.233,0.233-0.233h121.545
		c0.128,0,0.233,0.104,0.233,0.233v109.529c0,11.156,9.077,20.233,20.233,20.233h109.529c0.128,0,0.232,0.104,0.232,0.233V271.773z"
		/>
	<path d="M186.875,99.857h48.25c3.573,0,6.874-1.906,8.66-5c1.787-3.094,1.787-6.906,0-10L219.66,43.072
		c-1.786-3.094-5.087-5-8.66-5s-6.874,1.906-8.66,5l-24.125,41.785c-1.787,3.094-1.787,6.906,0,10
		C180.001,97.951,183.303,99.857,186.875,99.857z M211,68.072l6.804,11.785h-13.608L211,68.072z"/>
	<path d="M235.125,322.143h-48.25c-3.573,0-6.874,1.906-8.66,5c-1.787,3.094-1.787,6.906,0,10l24.125,41.785
		c1.786,3.094,5.087,5,8.66,5c3.572,0,6.874-1.906,8.66-5l24.125-41.785c1.787-3.094,1.787-6.906,0-10
		C241.999,324.049,238.698,322.143,235.125,322.143z M211,353.928l-6.804-11.785h13.608L211,353.928z"/>
	<path d="M378.929,202.34l-41.785-24.124c-3.094-1.787-6.906-1.787-10,0c-3.094,1.786-5,5.087-5,8.66v48.249
		c0,3.573,1.906,6.874,5,8.66c1.547,0.893,3.273,1.34,5,1.34s3.453-0.447,5-1.34l41.785-24.125c3.094-1.786,5-5.088,5-8.66
		C383.929,207.427,382.022,204.126,378.929,202.34z M342.144,217.804v-13.608L353.929,211L342.144,217.804z"/>
	<path d="M94.857,178.215c-3.094-1.786-6.905-1.786-10,0L43.072,202.34c-3.094,1.786-5,5.088-5,8.66c0,3.573,1.906,6.874,5,8.66
		l41.785,24.125c1.547,0.893,3.273,1.34,5,1.34s3.453-0.447,5-1.34c3.094-1.786,5-5.087,5-8.66v-48.249
		C99.857,183.303,97.951,180.001,94.857,178.215z M79.857,217.804L68.072,211l11.785-6.804V217.804z"/>
	<path d="M212,166.264c-25.222,0-45.741,20.52-45.741,45.741s20.519,45.741,45.741,45.741s45.741-20.519,45.741-45.741
		S237.222,166.264,212,166.264z M212,237.747c-14.193,0-25.741-11.547-25.741-25.741c0-14.194,11.547-25.741,25.741-25.741
		c14.194,0,25.741,11.547,25.741,25.741C237.741,226.199,226.194,237.747,212,237.747z"/>

		</g>

	</svg >
)


// WEBPACK FOOTER //
// ./src/layout/icons/Manipulate.tsx